// Unity-owned DOM inside the sandbox scrolls with the visual. No geometry travels to React.
export const interactionChrome = String.raw`
const chromeNodes = new Map();
const attachFilterTooltip = (root, button) => {
    const tooltip=document.createElement('div');
    tooltip.id='unity-filter-details'; tooltip.className='filter-tooltip';
    tooltip.setAttribute('role','tooltip'); tooltip.setAttribute('popover','manual'); tooltip.hidden=true;
    tooltip.innerHTML='<strong>Active filter</strong><div class="filter-description"></div><div class="filter-fields"></div><small>Click the filter badge to clear.</small>';
    root.appendChild(tooltip);
    button.setAttribute('aria-describedby',tooltip.id);
    let open=false, hideTimer;
    const hide = () => {
        clearTimeout(hideTimer);
        if(open && tooltip.hidePopover && tooltip.matches(':popover-open')) tooltip.hidePopover();
        open=false; tooltip.hidden=true;
        window.removeEventListener('scroll',hide,true);
        window.removeEventListener('resize',hide);
        document.removeEventListener('keydown',onKey,true);
    };
    const position = () => {
        const rect=button.getBoundingClientRect(), size=tooltip.getBoundingClientRect();
        const left=Math.max(8,Math.min(rect.right-size.width,innerWidth-size.width-8));
        const top=rect.top-size.height-8>=8 ? rect.top-size.height-8 : Math.min(rect.bottom+8,innerHeight-size.height-8);
        tooltip.style.left=left+'px'; tooltip.style.top=Math.max(8,top)+'px';
    };
    const show = () => {
        clearTimeout(hideTimer);
        if(button.hidden || !button.isConnected) return;
        tooltip.hidden=false;
        // A top-layer popover escapes template overflow/transform clipping while
        // remaining in this sandbox and the button's accessible shadow tree.
        if(!open && tooltip.showPopover) tooltip.showPopover();
        open=true; position();
        window.addEventListener('scroll',hide,true);
        window.addEventListener('resize',hide);
        document.addEventListener('keydown',onKey,true);
    };
    const onKey = event => {
        if(event.key==='Escape'){ hide(); event.stopPropagation(); }
    };
    const leave = () => { hideTimer=setTimeout(()=>{if(root.activeElement!==button) hide();},120); };
    button.addEventListener('pointerenter',show);
    button.addEventListener('pointerleave',leave);
    button.addEventListener('focus',show);
    button.addEventListener('blur',hide);
    tooltip.addEventListener('pointerenter',show);
    tooltip.addEventListener('pointerleave',leave);
    return {
        update(label, fields) {
            // Labels and values are live data, never HTML.
            tooltip.querySelector('.filter-description').textContent=label;
            tooltip.querySelector('.filter-fields').textContent=(fields || []).map(f=>f.column+': '+(f.value==null?'(Blank)':String(f.value))).join('\n');
            if(button.hidden) hide(); else if(open) position();
        },
        dispose() {
            hide(); tooltip.remove();
            button.removeEventListener('pointerenter',show);
            button.removeEventListener('pointerleave',leave);
            button.removeEventListener('focus',show);
            button.removeEventListener('blur',hide);
        }
    };
};
const chromeStyle = document.createElement('style');
chromeStyle.textContent = '[data-unity-inspected]{outline:2px solid #3b82f6!important;outline-offset:1px!important}[data-unity-hovered]:not([data-unity-inspected]){outline:1px dashed #3b82f6!important;outline-offset:1px!important}';
document.head.appendChild(chromeStyle);
let hoverElement = null;
const highlight = () => {
    document.querySelectorAll('[data-unity-inspected],[data-unity-hovered]').forEach(node=>{
        node.removeAttribute('data-unity-inspected'); node.removeAttribute('data-unity-hovered');
    });
    if (!inspecting) return;
    if (!selectedElement?.isConnected) selectedElement = locate(selection);
    if (selection?.selectedVisualIds?.length > 1) {
        selection.selectedVisualIds.forEach(id => locate({kind:'visual',id})?.setAttribute('data-unity-inspected',''));
    } else selectedElement?.setAttribute('data-unity-inspected','');
    if(hoverElement?.isConnected) hoverElement.setAttribute('data-unity-hovered','');
};
const removeChrome = node => {
    const entry = chromeNodes.get(node); if (!entry) return;
    entry.tooltip.dispose();
    entry.host.remove();
    if (entry.position != null && node.style.position==='relative') node.style.position=entry.position;
    chromeNodes.delete(node);
};
const clearChrome = () => { Array.from(chromeNodes.keys()).forEach(removeChrome); };
const refreshChrome = () => {
    if (chromeFrame) return;
    chromeFrame = requestAnimationFrame(() => {
        chromeFrame=0;
        const seen = new Set();
        document.querySelectorAll('[data-unity-visual],[data-unity-data]').forEach(node=>{
            const visualId=node.getAttribute('data-unity-visual'), dataId=node.getAttribute('data-unity-data');
            if(!visualId && node.closest('[data-unity-visual]')) return;
            const definition=visuals.find(v=>v.id===visualId);
            if(!definition && !dataKeys.includes(dataId)) return;
            const slots=definition ? definition.dataIds.map(key=>visualId+'/'+key) : [dataId];
            const busy=slots.some(key=>busySlots.includes(key)) || Array.from(requests.values()).some(r=>r.visualId===visualId);
            const source=!!visualId && interaction?.visualId===visualId;
            node.setAttribute('aria-busy',String(busy));
            if(!busy && !source) return;
            // SVG data marks share their SVG viewport; HTML registrations own their own chrome.
            if(node.namespaceURI==='http://www.w3.org/2000/svg') node=node.ownerSVGElement || node;
            seen.add(node);
            let entry=chromeNodes.get(node);
            if(!entry?.host.isConnected){
                if(entry) removeChrome(node);
                const host=document.createElement('unity-feedback');
                host.setAttribute('data-unity-feedback',visualId || dataId);
                host.style.cssText='position:absolute!important;inset:0!important;display:block!important;pointer-events:none!important;z-index:2147483646!important;';
                const root=host.attachShadow({mode:'open'});
                root.innerHTML='<style>:host{color:#2563eb;font:12px Arial,sans-serif}*{box-sizing:border-box}.busy{position:absolute;top:7px;left:7px;width:20px;height:20px;background:#fffffff5;border:1px solid #2563eb33;border-radius:50%;box-shadow:0 1px 5px #0f172a33;display:grid;place-items:center}.spinner{width:15px;height:15px;border:2px solid #2563eb40;border-top-color:#2563eb;border-radius:50%;animation:spin .8s linear infinite}.progress{position:absolute;top:0;left:0;right:0;height:2px;overflow:hidden;background:#bfdbfe}.progress:after{content:"";position:absolute;width:40%;height:100%;background:#3b82f6;animation:slide 1.2s ease-in-out infinite}.clear{position:absolute;bottom:6px;right:6px;display:flex;align-items:center;gap:4px;border:0;border-radius:999px;padding:5px 7px;color:#fff;background:#3b82f6;box-shadow:0 2px 5px #0003;pointer-events:auto;cursor:pointer}.clear:focus-visible{outline:2px solid #1e40af;outline-offset:2px}svg{width:14px;height:14px;fill:currentColor}[hidden]{display:none!important}@keyframes spin{to{transform:rotate(360deg)}}@keyframes slide{from{left:-40%}to{left:100%}}@media(prefers-reduced-motion:reduce){.spinner,.progress:after{animation:none}}</style><div class="progress" role="progressbar" aria-label="Applying visual cross-filter"></div><div class="busy" role="status" aria-label="Updating visual data"><span class="spinner"></span></div><button class="clear" type="button"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 3h16v2l-6 7v7l-4 2v-9L4 5z"/></svg><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6.4 5 5.6 5.6L17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6L6.4 19 5 17.6l5.6-5.6L5 6.4z"/></svg></button>';
                const button=root.querySelector('button');
                const tooltipStyle=document.createElement('style');
                tooltipStyle.textContent='.filter-tooltip{position:fixed;inset:auto;margin:0;width:max-content;max-width:min(320px,calc(100vw - 16px));max-height:calc(100vh - 16px);overflow:auto;padding:12px 14px;border:1px solid #dbe2ec;border-radius:8px;background:#fff;color:#172b4d;box-shadow:0 4px 18px #0f172a33;pointer-events:auto;z-index:2147483647;font:13px/1.5 Arial,sans-serif;white-space:normal;overflow-wrap:anywhere}.filter-tooltip strong{display:block;font-size:12px}.filter-description{margin-top:4px;color:#52617a}.filter-fields{margin-top:6px;white-space:pre-wrap}.filter-tooltip small{display:block;margin-top:8px;color:#64748b;font-size:11px}';
                root.appendChild(tooltipStyle);
                const tooltip=attachFilterTooltip(root,button);
                button.onclick=event=>{event.stopPropagation();send('clear-interaction');};
                let mount=host, position=null;
                if(node.namespaceURI==='http://www.w3.org/2000/svg'){
                    mount=document.createElementNS('http://www.w3.org/2000/svg','foreignObject');
                    mount.setAttribute('width','100%'); mount.setAttribute('height','100%'); mount.style.pointerEvents='none'; mount.appendChild(host);
                } else if(getComputedStyle(node).position==='static' || !getComputedStyle(node).position){
                    position=node.style.position; node.style.position='relative';
                }
                node.appendChild(mount);
                entry={host:mount,root,position,tooltip}; chromeNodes.set(node,entry);
            }
            entry.root.querySelector('.busy').hidden=!busy;
            entry.root.querySelector('.progress').hidden=!(busy && interaction);
            const button=entry.root.querySelector('.clear');button.hidden=!source;
            const label=interaction?.label || interaction?.fields.map(f=>f.column+' = '+String(f.value)).join(', ') || 'Active visual cross-filter';
            button.setAttribute('aria-label','Clear '+label);
            entry.tooltip.update(label,interaction?.fields);
        });
        Array.from(chromeNodes.keys()).filter(node=>!seen.has(node) || !node.isConnected).forEach(removeChrome);
        highlight();
    });
};
`;
